class FooterAccordion {
  constructor(container) {
    this.container = container;
    this.items = container.querySelectorAll('.footer-accordion__item');
    this.bindEvents();
  }

  bindEvents() {
    this.items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open || !window.matchMedia('(max-width: 749px)').matches) return;
        this.items.forEach((other) => {
          if (other !== item && other.open) {
            if (window.AccordionTransition) {
              window.AccordionTransition.close(other);
            } else {
              other.open = false;
            }
          }
        });
      });
    });
  }
}

function initFooterAccordions(root) {
  root.querySelectorAll('[data-footer-accordion]').forEach((el) => {
    if (el._footerAccordion) return;
    el._footerAccordion = new FooterAccordion(el);
  });
}

function destroyFooterAccordions(root) {
  root.querySelectorAll('[data-footer-accordion]').forEach((el) => {
    delete el._footerAccordion;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initFooterAccordions(document));
} else {
  initFooterAccordions(document);
}

document.addEventListener('shopify:section:load', (event) => {
  initFooterAccordions(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  destroyFooterAccordions(event.target);
});
